import { OptionType } from './minutes-card-popover-button'

/**
 * MinutesCardPopoverDispatcher
 * Dispatches a function based on the Option selected
 * from the Minutes Card Popover
 */
export const MinutesCardPopoverDispatcher = ({
    history,
    handleOpenMinutesModal,
    handleOpenExportOptionsModal,
    handleOpenDeleteMinutesConfirmation
}) => {
    // = = = = = = = = =
    // Actions
    // = = = = = = = = =
    const editMinutes = ({ minutesItem }) => {
        handleOpenMinutesModal('EDIT', minutesItem)
    }
    const duplicateMinutes = ({ minutesItem }) => {
        handleOpenMinutesModal('DUPLICATE', minutesItem)
    }
    const viewActions = ({ minutesItem }) => {
        history.push({ pathname: `/taker/${minutesItem.id}`, state: { from: '/' } })
    }
    const handleDeleteMinutes = ({ minutesItem, committeeId }) => {
        handleOpenDeleteMinutesConfirmation({ minutesId: minutesItem.id, committeeId })
    }
    const exportOptionsAction = ({ minutesItem, committeeId }) => {
        handleOpenExportOptionsModal(minutesItem, committeeId)
    }
    // = = = = = = = = =
    // Dispatcher
    // = = = = = = = = =
    const dispatchOption: Record<
        OptionType,
        ({ minutesItem, committeeId }: { minutesItem: any; committeeId: string }) => any
    > = {
        EDIT: editMinutes,
        ACTIONS: viewActions,
        DUPLICATE: duplicateMinutes,
        EXPORT: exportOptionsAction,
        DELETE: handleDeleteMinutes
    }
    const handleClickMinutesOptions = (
        optionValue: OptionType,
        minutesItem: any,
        committeeId: string
    ) => {
        const optionAction = dispatchOption[optionValue]
        optionAction({ minutesItem, committeeId })
    }

    return handleClickMinutesOptions
}
